/**
 * Created by wxb on 2016/12/1.
 */
import Timeago from 'timeago.js';
import Vue from 'vue';
/**
 *   对Date的扩展，将 Date 转化为指定格式的String
 *   月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *   年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 *   例子：
 *   (new Date()).Format('yyyy-MM-dd hh:mm:ss.S') ==> 2006-07-02 08:09:04.423
 *   (new Date()).Format('yyyy-M-d h:m:s.S')      ==> 2006-7-2 8:9:4.18
 */
export const fmtDate = (date, fmt) => { // author: meizz
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
};

/**
 * 调用Timeago库显示到现在的时间
 */
const MillisecondToDate = (time) => {
  var str = '';
  if (time !== null && time !== '') {
    let timeagoInstance = new Timeago();
    str = timeagoInstance.format(time, 'zh_CN');
  }
  return str;
};

/**
 * 格式化日期或时间
 * @param {string} time 需要格式化的时间
 * @param {bool} friendly 是否是fromNow
 */
export const getLastTimeStr = (time, friendly) => {
  if (friendly) {
    return MillisecondToDate(time);
  } else {
    return fmtDate(new Date(time), 'yyyy-MM-dd hh:mm');
  }
};

export const yoyoHighlight = (words, query) => {
  let iQuery = new RegExp(query, "ig");
  return words.toString().replace(iQuery, function(matchedTxt,a,b){
    return ('<div class=\'yoyo-highlight\'>' + matchedTxt + '</div>');
  });
};

export const checkPhone = function(val) {
  var filter = /^1[3|4|5|7|8][0-9]{9}$/;
  return !!filter.test(val);
};

export const checkMail = function(val) {
  var re = /\S+@\S+\.\S+/;
  return re.test(val);
};

export const initFileBaseUrl = function () {
  if (JSON.parse(localStorage.getItem('fileBaseUrl'))) {
    if ((JSON.parse(localStorage.getItem('fileBaseUrl')).videoBaseUrl && JSON.parse(localStorage.getItem('fileBaseUrl')).videoBaseUrl.indexOf('test') > -1) || (JSON.parse(localStorage.getItem('fileBaseUrl')).imageBaseUrl && JSON.parse(localStorage.getItem('fileBaseUrl')).imageBaseUrl.indexOf('test') > -1)) {
      getFileBaseUrl();
    }
  }
  if (!JSON.parse(localStorage.getItem('fileBaseUrl')) || !JSON.parse(localStorage.getItem('fileBaseUrl')).videoBaseUrl || !JSON.parse(localStorage.getItem('fileBaseUrl')).imageBaseUrl) {
    getFileBaseUrl();
  }
};

function getFileBaseUrl() {
  let baseUrlSet = {};
  Vue.http.get('/osg/resource/prefix/video').then(function (data) {
    baseUrlSet.videoBaseUrl = data.data.prefix;
    localStorage.setItem('fileBaseUrl', JSON.stringify(baseUrlSet));
  });
  Vue.http.get('/osg/resource/prefix/image').then(function (data) {
    baseUrlSet.imageBaseUrl = data.data.prefix;
    localStorage.setItem('fileBaseUrl', JSON.stringify(baseUrlSet));
  });
}

export const getParams = query => {
  if (!query) {
    return { };
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      let [ key, value ] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, { });
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const addParamsToUrl = (url, query, noLoginInfo) => {
  if (!noLoginInfo) {
    if (JSON.parse(localStorage.getItem('user')).parent.id) {
      url = url + ((url.indexOf('?') < 0) ? '?' : '&') + 'parentId=' + JSON.parse(localStorage.getItem('user')).parent.id;
    }
    if (JSON.parse(localStorage.getItem('user')).student.id) {
      url = url + ((url.indexOf('?') < 0) ? '?' : '&') + 'studentId=' + JSON.parse(localStorage.getItem('user')).student.id;
    }
    if (JSON.parse(localStorage.getItem('user')).deviceUUID) {
      url = url + ((url.indexOf('?') < 0) ? '?' : '&') + 'deviceUUID=' + JSON.parse(localStorage.getItem('user')).deviceUUID;
    }
  }

  Object.keys(query).forEach(function (key) {
    if (query[key]) {
      url = url + ((url.indexOf('?') < 0) ? '?' : '&') + key + '=' + query[key];
    }
  });

  return url;
};

export const removeURLParameter = (url, parameter) => {
  let urlparts= url.split('?');
  if (urlparts.length>=2) {
    let prefix= encodeURIComponent(parameter)+'=';
    let pars= urlparts[1].split(/[&;]/g);

    for (let i= pars.length; i-- > 0;) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
    return url;
  }
  else {
    return url;
  }
};

export const toHHMMSS = (secs) => {
  let sec_num = parseInt(secs, 10);
  let hours   = Math.floor(sec_num / 3600) % 24;
  let minutes = Math.floor(sec_num / 60) % 60;
  let seconds = sec_num % 60;
  return [hours,minutes,seconds]
    .map(v => v < 10 ? "0" + v : v)
    .filter((v,i) => v !== "00" || i > 0)
    .join(":")
};

export const initUser = function () {
  console.log(JSON.parse(localStorage.getItem('user')));
  if(!JSON.parse(localStorage.getItem('user')) || !JSON.parse(localStorage.getItem('user')).oauthTime){
    localStorage.setItem('user', JSON.stringify({anonymous: true, user: {}, wechat: {}}));
  }
  else {
    if (new Date().getTime() - JSON.parse(localStorage.getItem('user')).oauthTime > 24 * 3600 * 1000) {
      localStorage.setItem('user', JSON.stringify({anonymous: true, user: {}, wechat: {}}));
    }
  }
};

export const wechatOauthAndLogin = fullPath => {
  if (fullPath) {
    Vue.resource('/osg/mobile/wechat/oauth/url').get({redirect_uri: window.location.protocol + '//' + window.location.host + fullPath}).then(data => {
      if (data && data.errcode === 0) {
        const state = getParameterByName('state', data.data);
        window.location.replace(data.data);
      }
    })
  }
  else {
    window.location.replace(window.location.protocol + '//' + window.location.host);
  }
};

export const getUserInfo = (code, state, fullPath) => {
  const queryParams = {};
  queryParams.code = code;
  queryParams.state = state;
  if (fullPath.indexOf('expositorEdit') > -1) {
    queryParams.roleType = 10;
    queryParams.deviceUUID = getParameterByName('deviceUUID', fullPath);
    queryParams.isUpdate = getParameterByName('scanUpdate', fullPath);
  }
  return Vue.resource('/osg/mobile/wechat/oauth').get(queryParams).then(data => {
    if (data && data.errcode === 0) {
      let user = data.data;
      user.oauthTime = new Date().getTime();
      localStorage.setItem('user', JSON.stringify(user));
    }
    return data;
  })
};

export const reOauthUser = (fullPath) => {
  localStorage.setItem('user', JSON.stringify({anonymous: true, user: {}, wechat: {}}));
  let originPath = removeURLParameter(fullPath, 'code');
  originPath = removeURLParameter(originPath, 'state');
  wechatOauthAndLogin(originPath)
};

export const goLogin = () => {
  window.location.replace(window.location.protocol + '//' + window.location.host + '/login');
};

export const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};

export const isWechatBrowser = () => {
  if( typeof WeixinJSBridge !== "undefined" ) {
    return true;
  }
  else return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 || typeof navigator.wxuserAgent !== "undefined";
};

export const openInWebview = () => {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) === 'micromessenger') { // 微信浏览器判断
    return false
  } else if (ua.match(/QQ/i) === 'qq') { // QQ浏览器判断
    return false
  } else if (ua.match(/WeiBo/i) === "weibo") {
    return false
  } else {
    if (ua.match(/Android/i) != null) {
      return ua.match(/browser/i) == null
    } else if (ua.match(/iPhone/i) != null) {
      return ua.match(/safari/i) == null
    } else {
      return (ua.match(/macintosh/i) == null && ua.match(/windows/i) == null)
    }
  }
};

export const openApp = ({ios, android}) => {
  if(navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    let loadDateTime = new Date();
    window.setTimeout(function() {
      let timeOutDateTime = new Date();
      if(timeOutDateTime - loadDateTime < 5000) {
        window.location = ios.downloadLink; //download link
      }
      else {
        window.close();
      }
    }, 25);
    // window.location = ios.appUri || "weixin:// "; //app uri
    window.location = ios.appUri; //app uri
  }
  else if(navigator.userAgent.match(/android/i)) { //如果不行，就跟IOS逻辑一样
    // var state = undefined;
    // try {
    //   // state = window.open(android.appUri || "weixin://", '_blank'); //app uri
    //   state = window.open(android.appUri, '_blank'); //app uri
    // } catch(e) {}
    // if(state) {
    //   window.close();
    // }
    // else {
    //   window.location = android.downloadLink; //download link
    // }


    // let loadDateTime = new Date();
    // window.setTimeout(function() {
    //   let timeOutDateTime = new Date();
    //   if(timeOutDateTime - loadDateTime < 2200) {
    //     window.location = android.downloadLink; //download link
    //   }
    //   else {
    //     window.close();
    //   }
    // }, 25);
    // window.open(android.appUri || "weixin:// "); //app uri
    // // window.location = android.appUri; //app uri


    // clearTimeout(window.openAppTimer1);
    // clearTimeout(window.openAppTimer2);
    // var t = 1000, hasApp = true;
    // window.openAppTimer1 = setTimeout(function () {
    //   if (hasApp) {
    //     // window.open(android.appUri || "weixin:// ");
    //     window.open("weixin:// ");
    //   } else {
    //     // alert('你没有装app，请点击下方按钮下载。');
    //     window.location = android.downloadLink; //download link
    //   }
    //   document.body.removeChild(ifr);
    // }, 2000);
    // var t1 = Date.now();
    // var ifr = document.createElement("iframe");
    // // ifr.setAttribute('src', android.appUri);
    // ifr.setAttribute('src', "weixin:// ");
    // ifr.setAttribute('style', 'display:none');
    // document.body.appendChild(ifr);
    // window.openAppTimer2 = setTimeout(function () {
    //   var t2 = Date.now();
    //   if (!t1 || t2 - t1 < t + 100) {
    //     hasApp = false;
    //   }
    // }, t);


    const checkOpen = cb => {
      var _clickTime = +(new Date());
      function check(elsTime) {
        if ( elsTime > 3000 || document.hidden || document.webkitHidden) {
          cb(1);
        } else {
          cb(0);
        }
      }
      // 启动间隔 20ms 运行的定时器，并检测累计消耗时间是否超过 3000ms，超过则结束
      var _count = 0, intHandle;
      intHandle = setInterval(function(){
        _count++;
        var elsTime = +(new Date()) - _clickTime;
        if (_count>=100 || elsTime > 3000 ) {
          clearInterval(intHandle);
          check(elsTime);
        }
      }, 20);
    };

    // 在 iframe 中打开 app
    var ifr = document.createElement('iframe');
    // ifr.src = "weixin:// ";
    ifr.src = android.appUri;
    ifr.style.display = 'none';

    checkOpen(function(opened){
      if (opened) {
        // window.open("weixin:// ");
        window.open(android.appUri);
      }
      else {
        window.location = android.downloadLink; //download link
      }
    });

    document.body.appendChild(ifr);
    setTimeout(function() {
      document.body.removeChild(ifr);
    }, 2000);

  }
};

export const goApp = (appUri) => {
  if(navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    window.location = appUri
  }
  else if (navigator.userAgent.match(/android/i)) {
    window.open(appUri);
  }
};


export const config = {
  pageSize: 20,
  imgSize200_200: '?imageView/1/w/200/h/200',
  imgSize300_300: '?imageView/1/w/300/h/300',
  imgSize300_auto: '?imageMogr2/thumbnail/200x',
  imgSize600_auto: '?imageMogr2/thumbnail/600x',
  imgSize_auto_250: '?imageMogr2/thumbnail/x250',
  vframe_auto_200: '?vframe/jpg/offset/1/h/200/interlace/1',
  imgBlur: '/imageMogr2/blur/1x50',
  default_headImg: 'http://image.i.haierzhongyou.com/dz/giftset/d629c7d5-c4b5-46ec-a155-5058f46d7707.jpeg',
  default_headImg_t: 'http://image.i.teq6.com/dz/recommend/5d369d6f-e0e0-4a31-93f8-52b5f1d28d68.jpeg',




};





// WEBPACK FOOTER //
// ./src/libAndUtils/utils.js